import { createContext, useContext } from "react";

import type { IssueStatus } from "@/domains/pm/types";

export interface StatusAdminApi {
  /**
   * Open the New status dialog. The optional callback receives the new
   * status's key once it is saved — a surface that offers "New status" from a
   * status *picker* wanted to use the status, not merely to define it.
   */
  createStatus: (onCreated?: (key: IssueStatus) => void) => void;
}

export const StatusAdminContext = createContext<StatusAdminApi | null>(null);

/**
 * The page's status dialogs, for a surface that cannot mount its own.
 *
 * `StatusPicker` mounts `StatusManagementDialogs` itself and does not need
 * this. A right-click menu does: Radix unmounts its content the moment the
 * menu closes, which would take the dialog with it before it ever painted.
 * The New Issue form has the same problem in reverse — a dialog inside a
 * dialog — and reaches the page's for the same reason.
 *
 * Null when the page mounts no provider, or when the user cannot manage
 * statuses here; callers then simply do not offer the item.
 */
export function useStatusAdmin(): StatusAdminApi | null {
  return useContext(StatusAdminContext);
}
